export const validateLocation = (location, className) => {
    const locations = ['sliders-desktop', 'horizontal-box', 'vertical-box'];
    return locations.includes(location) ? className : '';
  }